import React, { useEffect } from 'react'
import { reduxForm } from 'redux-form'
import { FiCreditCard } from 'react-icons/fi'
import TextField from '../shared/TextField'
import { AuthWithCard } from './AuthWithCard/AuthWithCard'
import s from './AuthForm.module.scss'

let script_loaded = true
let plugin_installed = false
let requests = []

const AuthForm = ({ handleSubmit, isAuthCard, setIsAuthCard, onSubmit }) => {
  useEffect(() => {
    window.addEventListener('message', onMessage)
    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, [])

  function askPCSC(Command, onState, onAnswer, onError) {
    // console.log('askPCSC: ' + Command)
    // setIsAuthCard(true)
    if (!plugin_installed) {
      onError && onError(-2, 'Дополнение не установлено')
    }
    if (
      requests.find((element, index, array) => {
        return element.operation == Command
      })
    )
      return
    requests.push({ operation: Command, StateProc: onState, AnswerProc: onAnswer, ErrorProc: onError })
    window.postMessage(
      {
        direction: 'to_card_plugin',
        message: Command,
      },
      '*'
    )
  }

  function Init(onOK, onError) {
    askPCSC('test', undefined, onOK, onError)
  }
  function Read(onOK, onError, onState) {
    askPCSC('read', onState, onOK, onError)
  }

  function onCardRead(card) {
    setIsAuthCard(false)
    onSubmit({ rfid_token: card })
  }
  function onCardError(Code, error) {
    setIsAuthCard('error')
  }

  function onReading(state) {
    setIsAuthCard('reading')
  }

  function doRead() {
    if (!script_loaded) return
    setIsAuthCard(true)
    Read(onCardRead, onCardError, onReading)
  }

  // закрытие окна прерывает ожидание карты
  function closeCard() {
    requests = requests.filter(request => request.operation !== 'read')
    setIsAuthCard(false)
  }

  // function doCheck() {
  //   if (!script_loaded) return
  //   Init(
  //     result => {
  //       commandButton.disabled = false
  //     },
  //     (code, error) => {
  //       commandButton.disabled = true
  //       status_text.innerHTML += "<BR><font color='red'><ERROR:>" + error + '</font>'
  //     }
  //   )
  // }

  function onMessage(event) {
    if (
      event.source == window &&
      event.data &&
      event.data.message &&
      event.data.message.content &&
      event.data.direction == 'from_card_plugin'
    ) {
      plugin_installed = true
      var content = event.data.message.content
      console.log('answer to  : ' + JSON.stringify(content))

      var index_op = requests.findIndex((element, index, array) => {
        return element.operation == content.command
      })
      if (index_op >= 0) {
        if (content.AnswerType == 'state') {
          requests[index_op].StateProc && requests[index_op].StateProc(content.value)
        }
        if (content.AnswerType == 'error') {
          requests[index_op].ErrorProc && requests[index_op].ErrorProc(content.Code, content.value)
        }
        if (content.AnswerType == 'card') {
          requests[index_op].AnswerProc && requests[index_op].AnswerProc(content.value)
          requests.splice(index_op, 1)
        }
      }
    }
  }

  return (
    <form onSubmit={handleSubmit} className={s.form} autoComplete='off'>
      <div className={s.lf}>
        <label htmlFor='username'>Пользователь</label>
        <TextField className={s.field} id='username' name='username' placeholder='Логин' />
      </div>
      <div className={s.lf}>
        <label htmlFor='password'>Пароль</label>
        <TextField className={s.field} id='password' name='password' placeholder='Пароль' type='password' />
      </div>
      <button type='submit' className={`${s.button} ${s.primary}`}>
        Войти
      </button>
      <button type='button' className={`${s.button} ${s.ghost}`} onClick={doRead}>
        <FiCreditCard size={18} />
        Войти по карте
      </button>

      <AuthWithCard isAuthCard={isAuthCard} onClose={closeCard} />
    </form>
  )
}

export default reduxForm({
  form: 'auth',
})(AuthForm)
